import React, { useEffect, useMemo, useState } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
// utils
import Image from 'next/image';
import Link from 'next/link';
import { BsBuilding, BsFillHouseFill } from 'react-icons/bs';
import { HiMapPin } from 'react-icons/hi2';
import Map, { Marker } from 'react-map-gl';
import { ImagemMapa } from '../../../assets';
import { REACT_APP_MAPBOX_TOKEN } from '../../../configs/constants';
import styles from './mapa.module.css';

// interfaces
interface INetworkPieces {
    prop?: any;
    properties?: any;
    openMapa: any;
    setOpenMapa: any;
    tipo?: any;
    popup?: any
}

const Mapa: React.FC<INetworkPieces> = ({ setOpenMapa, prop, properties, openMapa, tipo, popup }) => {
    // constants
    // states
    const [latitude, setLatitude] = useState();
    const [longitude, setLongitude] = useState();
    const [openCard, setOpenCard] = React.useState(-1);
    const [viewState, setViewState] = React.useState({
        longitude: prop?.latitude_longitude ? prop?.latitude_longitude.replace("(","").replace(")","").split(",")[1] : '',
        latitude: prop?.latitude_longitude ? prop?.latitude_longitude.replace("(","").replace(")","").split(",")[0] : '',
        zoom: 17
    });

    const renderPath = (properti: any) => {
        const newPath = `/imovel/${properti?.id}`;
        return newPath;
    };

    useEffect(() => {
        const GetLatLong = () => {
            const latLong = prop?.latitude_longitude.replace("(","").replace(")","").split(",");
            setLatitude(latLong[0] || 0);
            setLongitude(latLong[1] || 0);
        }
        if(prop?.latitude_longitude){
            GetLatLong();
        }
    }, [prop?.latitude_longitude]);

    useEffect(() => {
        const GetLatLong = () => {
            setViewState({
                latitude: latitude,
                longitude: longitude,
                zoom: 17
            })
        }
        if(latitude && longitude){
            GetLatLong();
        }
    }, [latitude,longitude]);

    const markers = useMemo(() => ( latitude && longitude ?
        <Marker
            key={1}
            longitude={longitude}
            latitude={latitude}
            style={{ position: 'absolute'}}
            onClick={() => setOpenMapa(0)}
        >
            { prop?.tipo?.nome ?
                    prop?.tipo?.nome.includes('Apartamento') ?
                        <div className={styles.ponto}>
                            <BsBuilding
                                size={30}
                                color="#71eb71"
                                style={{ position: 'absolute'}}
                            />
                        </div>
                    :
                    prop?.tipo?.nome.includes('Terreno') ?
                            <div className={styles.ponto}>
                                <HiMapPin
                                    size={30}
                                    color="#71eb71"
                                />
                            </div>
                        :
                        <div className={styles.ponto}>
                            <BsFillHouseFill
                                size={30}
                                color="#71eb71"
                            />
                        </div>
                :
                <div className={styles.ponto}>
                    <BsFillHouseFill
                        size={30}
                        color="#71eb71"
                    />
                </div> }
        </Marker> : null
    ), [latitude, longitude, prop?.tipo?.nome, setOpenMapa]);
    const markers_semelhantes = useMemo(() =>  properties ? properties.map((propertie: {id: any; latitude_longitude: any; tipo: any }, cont: number) => (
    propertie?.latitude_longitude && (propertie?.latitude_longitude != prop?.latitude_longitude || !tipo) ?
        <Marker
            key={propertie?.id}
            longitude={Number(propertie?.latitude_longitude.replace("(","").replace(")","").split(",")[1])*1.00002}
            latitude={propertie?.latitude_longitude.replace("(","").replace(")","").split(",")[0]*1.00002}

            style={{ position: 'absolute'}}
            onClick={() => setOpenCard(cont)}
        >
            { propertie?.tipo ?
                propertie?.tipo?.nome.includes('Apartamento') ?
                    <div className={styles.ponto}>
                        <BsBuilding
                            size={30}
                            color="white"
                            style={{ position: 'absolute'}}
                        />
                    </div>
                :
                    propertie?.tipo?.nome.includes('Terreno') ?
                        <div className={styles.ponto}>
                            <HiMapPin
                                size={30}
                                color="white"
                            />
                        </div>
                    :
                    <div className={styles.ponto}>
                        <BsFillHouseFill
                            size={30}
                            color="white"
                        />
                    </div>
            :
            <div className={styles.ponto}>
                <BsFillHouseFill
                    size={30}
                    color="white"
                />
            </div> }
        </Marker>
        : null)
    ) : null, [prop?.latitude_longitude, properties, tipo]);

    if(openMapa){
        return (
            <div id="mapa" className={popup == 1 ? styles.container1 : styles.container}>
                <div className={styles.container2} onClick={() => openCard >= 0 ? setOpenCard(-1) : setOpenMapa(0)} style={popup == 1 ? {display: "none"} : {}}/>
                <div className={styles.adjust_closed_modal} style={popup == 1 ? {display: "none"} : {}}>
                    <div
                        className={styles.closed_modal}
                        onClick={() => openCard >= 0 ? setOpenCard(-1) : setOpenMapa(0)}
                    >
                        <IoCloseSharp size={36} color="#ffffff" />
                    </div>
                </div>
                <div className={styles.adjust_img}>
                    <Map reuseMaps
                            {...viewState}
                            maxZoom={18}
                            minZoom={8}
                            onMove={evt => setViewState(evt.viewState)}
                            mapboxAccessToken={REACT_APP_MAPBOX_TOKEN}
                            style={{width: '100%', height: '80vh'}}
                            mapStyle="mapbox://styles/mapbox/outdoors-v9"
                    >
                        {markers && prop?.latitude_longitude && tipo ? markers :null }
                        {markers_semelhantes && properties ? markers_semelhantes : null}
                    </Map>
                    { openCard >= 0 && properties[openCard] ?
                        <>
                            <div className={styles.container3} onClick={() => setOpenCard(-1)}/>
                            <div className={styles.card}>
                                <Image
                                    width={300}
                                    height={250}
                                    alt='Foto do imóvel'
                                    className={styles.card_photo}
                                    src={properties[openCard]?.fotos[0]?.url_foto.replace("_g","_m")}>
                                </Image>
                                <div className={styles.adjust_closed_modal}>
                                    <div
                                        className={styles.closed_modal}
                                        onClick={() => setOpenCard(-1)}
                                    >
                                        <IoCloseSharp size={30} color="#ffffff" />
                                    </div>
                                </div>
                                <div className={styles.sombra}/>
                                <div className={styles.card_details} style={{top: '180px'}}>
                                    { properties[openCard]?.cidade?.nome && properties[openCard]?.bairro?.nome ? `${properties[openCard]?.cidade?.nome} - ${properties[openCard]?.bairro?.nome} `:` ${properties[openCard]?.cidade?.nome}`}
                                </div>
                                <div className={styles.card_details} style={{top: '200px'}}>
                                    { properties[openCard]?.tipo?.nome ? `${properties[openCard]?.tipo?.nome} ` : ""}{properties[openCard]?.area_total ? ` - ${properties[openCard]?.area_total} ${properties[openCard]?.area_tipo || 'm²'}` : properties[openCard]?.area_privativa ? `- ${properties[openCard]?.area_privativa} ${properties[openCard]?.area_tipo || 'm²'}` : ""}
                                </div>
                                <div className={styles.card_details} style={{top: '220px'}}>
                                    { properties[openCard]?.venda ? `Venda`:`${properties[openCard]?.aluguel}` ? `Aluguel` : `Temporada`} {`- Código: ${properties[openCard]?.referencia} `}
                                </div>
                                <div className={styles.card_description}>
                                    <Link href={renderPath(properties[openCard])} target='_blank' rel="noopener noreferrer" passHref>
                                        <div className={styles.button}>Ver imóvel</div>
                                    </Link>
                                </div>
                            </div>
                        </>
                    : null }
                </div>
            </div>
        );
    } else {
        return (
            <div className={styles.mapa} onClick={() => setOpenMapa(1)}>
                <Image
                    width={2000}
                    height={150}
                    src={ImagemMapa.src}
                    className={styles.image_mapa}
                    alt="Localização no mapa"
                >
                </Image>
                <div className={styles.button_mapa}>
                    VER MAPA
                </div>
            </div>
        );
    }
};

export default Mapa;
